import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { UsersView } from './Users';

import { Button } from '@/components/ui/Button';
import { Card, CardContent } from '@/components/ui/Card';
import { ROUTE_PATHS } from '@/config/constants';

export function AdminUsers() {
  const navigate = useNavigate();

  return (
    <Card className="min-h-screen rounded-lg shadow">
      <CardContent>
        <div className="mt-2 border-b bg-white">
          <div className="container mx-auto px-4 py-6">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Users</h1>
                <p className="mt-1 text-gray-600">
                  Create and manage user accounts
                </p>
              </div>
              <Button onClick={() => navigate(ROUTE_PATHS.ADMIN_USERS_CREATE)}>
                <Plus className="mr-2 h-4 w-4" /> Create New User
              </Button>
            </div>
          </div>
        </div>
        <div className="rounded-lg bg-gray-50">
          <div className="container mx-auto px-4 py-6">
            <UsersView />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
